<div class="card bg-light border-0">

  <div class="card-body">
    <div class="card-title">
      <div class="pb-1 history-number">
        <span class="me-4">
          Order #:
          <a [href]="'order-summary?ID=' + cart?.id"
             target="_blank"
             rel="opener">
          {{ cart?.id }}
          </a>
        </span>
        <app-cart-status-badge [cartStatus]="cart?.status"></app-cart-status-badge>
      </div>
      <div class="pb-1 history-date">{{ cart?.statusDate |date: 'medium' }}</div>
    </div>

    <div *ngFor="let item of items; let i=index">
      <div class="row mt-4">
        <div class="col-12 col-md-6">
          <p *ngIf="i===0" class="item-column-header">Item(s)</p>
          <p class="purchase-title">
            <app-purchase-title
              [product]="item.product"
              [offer]="item.offering">
            </app-purchase-title>
          </p>
        </div>
        <div class="col-4 col-md-2 mt-md-0">
          <p *ngIf="i===0" class="item-column-header text-md-end">Qty</p>
          <p class="text-md-end">{{ item.cartItem.quantity }}</p>
        </div>
        <div class="col-4 col-md-2 mt-md-0">
          <p *ngIf="i===0" class="item-column-header text-md-end">Price</p>
          <p class="text-md-end">{{ item.cartItem.price | currency }}</p>
        </div>
        <div class="col-4 col-md-2 mt-md-0">
          <p *ngIf="i===0" class="item-column-header text-end">Tax</p>
          <p class="text-end">{{ item.cartItem.tax | currency }}</p>
        </div>
      </div>
    </div>

    <div class="mt-1">
      <span class="history-total float-end">Total&nbsp; {{ total | currency }}</span>
    </div>

  </div>
</div>
